const GoogleIdentityHeadScript = () => {
  return (
    <script src="https://accounts.google.com/gsi/client" id="gsi-client" async defer />
  )
}

export default GoogleIdentityHeadScript
